import { WebStorageStateStore, type UserManagerSettings } from 'oidc-client-ts';

const keycloakUrl = import.meta.env.VITE_KEYCLOAK_URL;
const keycloakRealm = import.meta.env.VITE_KEYCLOAK_REALM;
const clientId = import.meta.env.VITE_KEYCLOAK_CLIENT_ID;

if (!keycloakUrl || !keycloakRealm || !clientId) {
  throw new Error(
    'Missing Keycloak env vars: VITE_KEYCLOAK_URL, VITE_KEYCLOAK_REALM, VITE_KEYCLOAK_CLIENT_ID',
  );
}

// sessionStorage (not localStorage) tightens the XSS blast radius and ensures tokens
// do not outlive the tab. ID token claims are sufficient — userinfo endpoint is skipped.
export const oidcConfig: UserManagerSettings = {
  authority: `${keycloakUrl}/realms/${keycloakRealm}`,
  client_id: clientId,
  redirect_uri: `${window.location.origin}/auth/callback`,
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid profile email',
  automaticSilentRenew: true,
  loadUserInfo: false,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
};
